import compiler from 'shared_src/igao/compiler'

import igao from '../../lib/igao.js'
import { compartmentReceive } from '../PatientFolder/patientActions.js'

export function read (resource, path, setData) {
  return ids => igao.read({
    resource,
    path,
    data: ids
  }).then(current => {
    setData(proposedData => {
      const proposed = { data: proposedData }
      const compiled = compiler.compile({
        current,
        proposed
      })
      return compiled.data
    })
  })
}

export function sendDraft (resource, path, data, setData, setDraft) {
  return igao
    .set({
      resource,
      path,
      data
    })
    .then(current => {
      setData(proposedData => {
        const proposed = { data: proposedData }
        const compiled = compiler.compile({
          current,
          proposed
        })
        setDraft({
          set: true,
          data: compiled
        })
        return compiled.data
      })
    })
    .catch(error => {
      setDraft({ error })
      setData(data)
    })
}

export function resolve (resource, path, data, setData, setDraft) {
  setDraft({ setting: true })
  return igao.resolve({
    resource,
    path,
    data
  })
    .then(current => {
      setData(current.data)
      setDraft({ set: true })
    })
    .catch(error => {
      setDraft({ error })
      setData(data)
    })
}

export function discard (resource, path, setData, setDraft) {
  return igao
    .discard({
      resource,
      path
    })
    .then(current => {
      setDraft({ get: true })
      setData({ ...current?.data })
    })
    .catch(error => {
      setDraft({ error })
    })
}

export function publish (resource, path, setData, setDraft, dispatch, data) {
  return igao
    .publish({
      resource,
      path
    })
    .then(current => {
      setData({ ...current?.data })
      setDraft({
        get: true,
        data
      })
      dispatch(compartmentReceive(resource))
    })
    .catch(error => {
      setDraft({ error })
    })
}
